import { Box, ButtonBase, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const UNIVERSAL_BUTTON_STYLES = {
  STYLE1: "style1",
  SQUARE: "square",
};

const sx = {
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.25,
    minWidth: 34,
    px: 0.25,
    py: 0.125,
    borderRadius: 1,
    flexShrink: 0,
  },
  circle: (color, size) => ({
    width: size,
    height: size,
    borderRadius: "999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color,
    transition: "transform 120ms ease",
  }),
  square: (color, size) => ({
    width: size,
    height: size,
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: color,
    transition: "transform 120ms ease",
  }),
  label: (labelColor) => ({
    fontSize: 9,
    lineHeight: 1.1,
    fontWeight: 500,
    color: labelColor,
    textTransform: "none",
    whiteSpace: "nowrap",
    maxWidth: 56,
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
};

const BaseButton = ({
  label,
  icon,
  circleColor,
  iconColor,
  labelColor,
  circleSize = 30,
  shapeStyle = "circle",
  sx: sxProp,
  ...props
}) => (
  <ButtonBase
    sx={[
      sx.root,
      (theme) => ({
        [theme.breakpoints.down("sm")]: {
          minWidth: 32,
          "& .ua-btn-shape": {
            width: 28,
            height: 28,
          },
          "& .ua-btn-label": {
            fontSize: 8,
            maxWidth: 44,
          },
        },
        "&:hover .ua-btn-shape": {
          transform: "translateY(-1px)",
        },
        "&:hover .ua-btn-label": {
          color: theme.palette.text.primary,
        },
        "&:focus-visible": {
          outline: `2px solid ${alpha(theme.palette.primary.main, 0.4)}`,
          outlineOffset: 1,
        },
      }),
      sxProp,
    ]}
    {...props}
  >
    <Box
      className="ua-btn-shape"
      sx={(theme) =>
        shapeStyle === "square"
          ? sx.square(circleColor || theme.palette.action.hover, circleSize)
          : sx.circle(circleColor || theme.palette.action.hover, circleSize)
      }
    >
      <Box
        sx={(theme) => ({
          display: "inline-flex",
          color: iconColor || theme.palette.text.secondary,
          "& .MuiSvgIcon-root": { fontSize: 16 },
        })}
      >
        {icon}
      </Box>
    </Box>
    {label && (
      <Typography className="ua-btn-label" sx={sx.label(labelColor || "text.secondary")}>
        {label}
      </Typography>
    )}
  </ButtonBase>
);

const UniversalActionButton = ({ styleType = UNIVERSAL_BUTTON_STYLES.STYLE1, ...props }) => {
  const shapeStyle = styleType === UNIVERSAL_BUTTON_STYLES.SQUARE ? "square" : "circle";
  return <BaseButton shapeStyle={shapeStyle} {...props} />;
};

export default UniversalActionButton;
